import axios from 'axios';

import { getToken } from '../utils/utils'

const apiAxios = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER_ADDRESS,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiAxios.interceptors.request.use(async (config) => {
    // リクエストの前に実行される処理
    if (config.headers) {
        const accessToken = (await getToken().then()).toString();
        config.headers['Authorization'] = accessToken;
    }
    return config
  });

export default apiAxios;

